import { CenterAlignedLoader } from '@medly-components/core';
import { ReactNode, useEffect } from 'react';

import Error from 'pages/Error';
import { useAuth } from '../../../hooks/useAuth/useAuth';

/**
 * AuthProtectedRoute responsible for protected route against user login.
 */
export const AuthProtectedRoute = ({ children }: { children: ReactNode }) => {
    const { authorize, error, loading } = useAuth();

    useEffect(() => {
        authorize();
        //TODO: Adding dependency causing api calls more than once.
        // Removed it for now, however the dependency need to be added.
    }, []);

    if (loading) {
        return <CenterAlignedLoader />;
    }

    if (error) {
        return <Error />;
    }

    return <>{children}</>;
};
